import React from 'react'

import Modal from 'components/Modal'
import { aleloPodGroups, groups, others } from 'constants/pod-groups'

import {
    Container,
    Title,
    Subtitle,
    Icon,
    List,
    Name,
    Item,
    Button
} from './style'

const ProductOthersModal = ({ onClose = () => {} }) => {
    const group = aleloPodGroups.find((g) => g.type === groups.OUTROS)

    return (
        <Modal open={true} onClick={onClose} closeBtn={true}>
            <Container data-testid={`${group.desc}Tooltip`}>
                <Icon src={group.icon} alt={`Icone Alelo Pod ${group.desc}`} />
                <Title>{group.desc}</Title>
                <Subtitle>
                    Quais benefícios então inclusos em Outros Auxílios?
                </Subtitle>
                <List>
                    {others.map((other) => (
                        <Item key={other.title}>
                            <img
                                src={other.icon}
                                alt={`Icone Alelo Pod ${other.title}`}
                            />
                            <Name>{other.title}</Name>
                        </Item>
                    ))}
                </List>
                <Button type="button" onClick={onClose}>
                    Entendi
                </Button>
            </Container>
        </Modal>
    )
}

export default ProductOthersModal
